import React from 'react';
import Sectors from '../components/Sectors';

const SectorsPage = () => {
  return (
    <div>
      <Sectors />
    </div>
  );
};

export default SectorsPage;





